import atgBrandLogo from '@/assets/img/logos/progressico2.png';
import atgBrandLogoWhite from '@/assets/img/logos/progressico2white.png';
import megaBrandLogo from '@/assets/img/logos/Mega/progressico.png';
import megaBrandLogoWhite from '@/assets/img/logos/Mega/progressicowhite.png';
import agroupBrandLogo from '@/assets/img/logos/Agroup/progressico.png';
import agroupBrandLogoWhite from '@/assets/img/logos/Agroup/progressicowhite.png';

const api =
  process.env.NODE_ENV === "production"
    ? "https://medical-account-api.progress-ims.com/api"
    : "https://localhost:7175/api";
const smsapi = "https://smsapi.huestimates.net/SendSms";
const login = "https://progress-login.azersigorta.az/";
const signalapi = process.env.NODE_ENV === "production"
  ? "https://medical-account-api.progress-ims.com/signalr"
  : "https://localhost:7175/signalr";

let baseURL = window.location.origin;

// Always use current origin so local ports (8080/8081/...) stay correct
const weblink = baseURL + "/";

// ateshgah
// progress-ims

const recaptchaKey = process.env.NODE_ENV === "production"
  ? "6LcH2Y4rAAAAAGGCm5YLa1yhN7A2GCSnvLaG3YGO"
  : "6LcaCygqAAAAAN1cRBFziTp3m4ANLorzOKb4OkjN";




const fileurl = process.env.NODE_ENV === "production"
  ?
  "https://inspector-files.progress-ims.com/2024/"
  : "http://localhost:5002/";

const standalone = true;

let imgFile = 'Atg'

const domain = window.location.host
var subdomain = domain.split('.')[0]

function getBrandLogo() {
  if (imgFile === 'Mega') {
    return megaBrandLogo;
  }
  if (imgFile === 'Agroup') {
    return agroupBrandLogo;
  }
  return atgBrandLogo;
}

function getBrandLogoWhite() {
  if (imgFile === 'Mega') {
    return megaBrandLogoWhite;
  }
  if (imgFile === 'Agroup') {
    return agroupBrandLogoWhite;
  }
  return atgBrandLogoWhite;
}

function applyBrandPalette(root, palette) {
  root.style.setProperty('--bs-info', palette.info);
  root.style.setProperty('--bs-success', palette.success);
  root.style.setProperty('--bs-warning', palette.warning);
  root.style.setProperty('--bs-info-soft', palette.infoSoft);
  root.style.setProperty('--bs-success-soft', palette.successSoft);
  root.style.setProperty('--bs-warning-soft', palette.warningSoft);
  root.style.setProperty('--info-color', palette.info);
  root.style.setProperty('--app-brand', palette.success);
  root.style.setProperty('--app-brand-deep', palette.info);
}

function setCssVariables() {
  const root = document.documentElement;

  if (subdomain.includes('medical-account-mega')) {
    imgFile = 'Mega'
    applyBrandPalette(root, {
      info: '#0a7a3c',
      infoSoft: '#0f9a4d',
      success: '#0a7a3c',
      successSoft: '#0f9a4d',
      warning: '#b45309',
      warningSoft: '#d97706',
    });
    root.style.setProperty('--app-brand-deep', '#065f2f');
  } else if (subdomain.includes('medical-account-agroup')) {
    imgFile = 'Agroup'
    applyBrandPalette(root, {
      info: '#9b1c1c',
      infoSoft: '#b91c1c',
      success: '#9b1c1c',
      successSoft: '#b91c1c',
      warning: '#b45309',
      warningSoft: '#d97706',
    });
    root.style.setProperty('--app-brand-deep', '#7f1d1d');
  } else {
    imgFile = 'Atg'
    applyBrandPalette(root, {
      info: '#0b4f9c',
      infoSoft: '#1a6fc4',
      success: '#1570b5',
      successSoft: '#1a6fc4',
      warning: '#c9951a',
      warningSoft: '#d4a017',
    });
    root.style.setProperty('--app-brand-deep', '#0a3d7a');
  }
}

setCssVariables();



function HtmlNewLine(value) {
  return value.replace(/(?:\r\n|\r|\n)/g, "<br />");
}

function Round2(num) {
  return Math.round(num * 100) / 100;
}

function DaysBetween(dt1, dt2) {
  var oneday = 1000 * 60 * 60 * 24;
  dt1 = new Date(dt1);
  dt2 = new Date(dt2);
  var diff = Math.round(dt2.getTime() - dt1.getTime()) / oneday;

  var res = diff.toFixed(0);
  return res;
}

function DateToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  return year + "-" + month + "-" + date;
}

function DateTimeToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");

  return (
    year + "-" + month + "-" + date + " " + hour + ":" + minutes + ":" + seconds
  );
}

function DateTimeReverseToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");
  return (
    date + "-" + month + "-" + year + " " + hour + ":" + minutes + ":" + seconds
  );
}


function DateTimeReverseToString1(dt) {

  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");

  return (
    month + "-" + date + "-" + year + " " + hour + ":" + minutes + ":" + seconds
  );
}

function DateTimeToJson(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");

  return (
    year + "-" + month + "-" + date + "T" + hour + ":" + minutes + ":" + seconds
  );
}

function AddMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}

function AddDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
function MonthName(month) {
  const monthNames = [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "İyun",
    "İyul",
    "Avqust",
    "Sentyabr",
    "Oktyabr",
    "Noyabr",
    "Dekabr"
  ];
  return monthNames[month];
}

function NumberFormat(val, digits) {
  return val.toLocaleString(
    "ru-RU", // leave undefined to use the visitor's browser
    // locale or a string like 'en-US' to override it.
    { minimumFractionDigits: digits }
  );
}

function parseAzMobileDigits(value) {
  const digits = String(value || "").replace(/#/g, "").replace(/\D/g, "");
  return digits.startsWith("994") ? digits.slice(3, 12) : digits.slice(0, 9);
}

function formatAzMobileMask(value) {
  const digits = parseAzMobileDigits(value);
  if (!digits) {
    return "";
  }

  const parts = [];
  if (digits.length > 0) parts.push(digits.slice(0, 2));
  if (digits.length > 2) parts.push(digits.slice(2, 5));
  if (digits.length > 5) parts.push(digits.slice(5, 7));
  if (digits.length > 7) parts.push(digits.slice(7, 9));

  return parts.join(" ");
}

function formatAzMobileMaskTemplate(value) {
  const digits = parseAzMobileDigits(value);
  const groups = [2, 3, 2, 2];
  let digitIndex = 0;

  return groups
    .map((groupSize) => {
      let group = "";
      for (let i = 0; i < groupSize; i += 1) {
        group += digitIndex < digits.length ? digits[digitIndex++] : "#";
      }
      return group;
    })
    .join(" ");
}

function parseAzMobileMaskInput(value) {
  return parseAzMobileDigits(value);
}

const AZ_MOBILE_MASK_DIGIT_SLOTS = [0, 1, 3, 4, 5, 7, 8, 10, 11];

function getAzMobileDigitIndexFromCursor(cursorPos) {
  let index = 0;
  for (const slot of AZ_MOBILE_MASK_DIGIT_SLOTS) {
    if (cursorPos > slot) {
      index += 1;
    } else {
      break;
    }
  }
  return index;
}

function getAzMobileCursorPos(digitIndex) {
  if (digitIndex <= 0) {
    return AZ_MOBILE_MASK_DIGIT_SLOTS[0];
  }
  if (digitIndex >= AZ_MOBILE_MASK_DIGIT_SLOTS.length) {
    return AZ_MOBILE_MASK_DIGIT_SLOTS[AZ_MOBILE_MASK_DIGIT_SLOTS.length - 1] + 1;
  }
  return AZ_MOBILE_MASK_DIGIT_SLOTS[digitIndex];
}

function formatAzMobileFull(value) {
  const digits = parseAzMobileDigits(value);
  if (!digits) {
    return "";
  }
  return `+994 ${formatAzMobileMask(digits)}`;
}

function normalizeAzMobilePhone(value) {
  const digits = parseAzMobileDigits(value);
  return digits ? `994${digits}` : "";
}

function swalDialogClass() {
  return {
    popup: "app-confirm-dialog",
    confirmButton: "btn action-btn action-btn--info action-btn--md",
    cancelButton: "btn action-btn action-btn--muted action-btn--md",
  };
}

export {
  // ShowLink,
  HtmlNewLine,
  api,
  signalapi,
  smsapi,
  fileurl,
  standalone,
  weblink,
  Round2,
  recaptchaKey,
  DaysBetween,
  DateToString,
  DateTimeToString,
  AddMonths,
  AddDays,
  MonthName,
  NumberFormat,
  parseAzMobileDigits,
  formatAzMobileMask,
  formatAzMobileMaskTemplate,
  parseAzMobileMaskInput,
  getAzMobileDigitIndexFromCursor,
  getAzMobileCursorPos,
  formatAzMobileFull,
  normalizeAzMobilePhone,
  DateTimeToJson,
  DateTimeReverseToString,
  DateTimeReverseToString1,
  login,
  imgFile,
  getBrandLogo,
  getBrandLogoWhite,
  swalDialogClass
};
